import { Component, h, Prop } from "@stencil/core";
import { AccessibilityUtils } from "../../core/utils/AccessibilityUtils";

@Component({
    tag: "snt-source-link",
    styleUrl: "source-link-component.scss",
    shadow: false,
})
export class SourceLinkComponent {
    static readonly TAG_NAME = "snt-source-link";

    @Prop({ reflect: true }) href: string;
    @Prop({ reflect: true }) target: string;
    @Prop({ reflect: true }) ariaLabel: string;
    @Prop({ reflect: true }) rel: string;

    render() {
        let content: string[];
        let title = AccessibilityUtils.getNewWindowTitle();
        let text = AccessibilityUtils.getNewWindowText();
        if (this.target === "_blank") {
            content = [
                    <span class="link-content"><slot/></span>,
                    <span class="icon-font icon-new-window" title={title}>
                        <span class="sr-only"> {text}</span>
                    </span>
            ];
        } else {
            content = (
                <span class="full-content">
                    <slot />
                </span>
            );
        }

        return (
            <a
                href={this.href}
                target={this.target}
                aria-label={this.ariaLabel}
                rel={this.rel}
            >
                {content}
            </a>
        );
    }
}
